import { Modal, Form, Button, OverlayTrigger, Popover, Alert, Col } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import Required from '../Required';
import './ModalEditReceipt.less';
import { isAdmin } from '../../services/rolesSvc';
import DateTimePicker from 'react-datetime-picker';
import Select from 'react-select';

const stylePopoverBody = {
  whiteSpace: 'pre-wrap',
  fontSize: '13px',
  lineHeight: '18px',
  textAlign: 'center',
  padding: '28px 20px',
  color: '#72808E',
};

export default function ModalEditReceipt(props) {
  const {
    onSave,
    onClose,
    onStateChange,
    onValueChange,
    onResultValueChange,
    isSend,
    show,
    value,
    resultValue,
    mainPerformer,
    projectsWithContract,
    projId,
    policyId,
    showResultField,
    status,
  } = props;

  const [val, setVal] = useState();
  const [state, setState] = useState();
  const [resultVal, setResultVal] = useState();
  const [formStateReady, setFormStateReady] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setVal(value.toFixed(2));
  }, [value])
  useEffect(() => {
    setResultVal(resultValue);
  }, [resultValue])
  useEffect(() => {
    setState(mainPerformer);
  }, [mainPerformer])

  const projects = projectsWithContract?.projs?.length || projectsWithContract?.strategies?.length 
  ? [
      ...projectsWithContract?.projs,
      ...projectsWithContract?.strategies
    ]
    .filter(e => e.originId !== projId && e.id !== policyId)
    .map((e) => {
      return e.type === 'strategy' || e.type === 'policy' 
      ? <p key={e.id} style={{ marginTop: 5}}>
        {e.num} {e.name.trim()}, % участия - {new Intl.NumberFormat('ru', {style: 'decimal', minimumFractionDigits: 2}).format(e?.share * 100)}
      </p>
      : (
        <p key={e.originId} style={{ marginTop: 5}}>
          {e?.fullNumber ? e?.fullNumber : ''}{e?.fullNumber ? ' ' : ''}{e?.name.trim()}{e?.head?.displayName ? `, руководитель проекта: ${e?.head?.displayName}` : ''}{e?.strategyName ? `, реализуемого в рамках стратегического проекта "${e?.strategyName}"` : ''}, % участия - {new Intl.NumberFormat('ru', {style: 'decimal', minimumFractionDigits: 2}).format(e?.share * 100)}
        </p>
      )
    }) 
  : null;
  
  const handleSave = async (e) => {
    if (val || val == '0') {
      await onSave(e);
    }
    setLoading(false);
  };

  const handleSubmitForm = () => {
    if (resultVal !== resultValue) {
      onResultValueChange(resultVal);
    }
    if (val !== value) {
      onValueChange(val);
    }
    if (state !== mainPerformer) {
      onStateChange(state);
    }
    setFormStateReady(true);
  };

  useEffect(() => {
    if (formStateReady) {
      setLoading(true);
      handleSave(isSend)
      setFormStateReady(false);
    }
  }, [formStateReady]);

  const renderTooltip = (props) => (
    <Popover {...props}>
      <Popover.Body style={stylePopoverBody}>
        {projId && 'Отметить, если команда проекта является основным исполнителем договора'}
        {policyId && 'Отметить, если команда политики развития является основным исполнителем договора'}
      </Popover.Body>
    </Popover>
  );

  const renderTooltipPercent = (props) => (
    <Popover {...props}>
      <Popover.Body style={stylePopoverBody}>
        Введите % участия в реализации договора (не более 100%)
      </Popover.Body>
    </Popover>
  );

  return (
    <Modal className='modal-receipts-container' show={show}>
      <Modal.Header>
        {isSend ? "Отправить на согласование" : "Редактирование данных договора"}
      </Modal.Header>
      <Modal.Body style={{ height: 'auto' }}>
        {status === "approved" && <div style={{ marginBottom: '20px', fontWeight: '600', color: '#dc3545' }}>После редактирования статус договора изменится на "Новый"</div>}
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 20 }}>
          <Form.Group style={{ maxWidth: '165px' }}>
            <Form.Label style={{ color: '#7F7F7F', fontWeight: 600 }}>
              %
              {' '}
              <Required />
            </Form.Label>
            <OverlayTrigger
              placement='top'
              overlay={renderTooltipPercent}
            >
              <svg style={{margin: 'auto 8px'}} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="8" cy="8" r="7.5" stroke="#D5D9DD"/>
                <path d="M8.58838 9.6958H7.39062C7.39421 9.36279 7.42285 9.0835 7.47656 8.85791C7.53027 8.62874 7.61979 8.42106 7.74512 8.23486C7.87402 8.04867 8.04411 7.85173 8.25537 7.64404C8.42008 7.48649 8.56868 7.33789 8.70117 7.19824C8.83366 7.05501 8.93929 6.90462 9.01807 6.74707C9.09684 6.58594 9.13623 6.40153 9.13623 6.19385C9.13623 5.96826 9.09863 5.77669 9.02344 5.61914C8.94824 5.46159 8.83724 5.34163 8.69043 5.25928C8.5472 5.17692 8.36816 5.13574 8.15332 5.13574C7.97428 5.13574 7.80599 5.17155 7.64844 5.24316C7.49089 5.3112 7.36377 5.41862 7.26709 5.56543C7.17041 5.70866 7.11849 5.89844 7.11133 6.13477H5.81689C5.82406 5.68359 5.93148 5.30404 6.13916 4.99609C6.34684 4.68815 6.62614 4.45719 6.97705 4.30322C7.32796 4.14925 7.72005 4.07227 8.15332 4.07227C8.63314 4.07227 9.04313 4.15462 9.3833 4.31934C9.72347 4.48047 9.98307 4.7168 10.1621 5.02832C10.3447 5.33626 10.436 5.70866 10.436 6.14551C10.436 6.46061 10.3734 6.74707 10.248 7.00488C10.1227 7.25911 9.9598 7.49723 9.75928 7.71924C9.55876 7.93766 9.34212 8.15609 9.10938 8.37451C8.90885 8.55713 8.77279 8.75586 8.70117 8.9707C8.62956 9.18197 8.59196 9.42367 8.58838 9.6958ZM7.2832 11.3716C7.2832 11.1782 7.34945 11.0153 7.48193 10.8828C7.61442 10.7467 7.79525 10.6787 8.02441 10.6787C8.25358 10.6787 8.43441 10.7467 8.56689 10.8828C8.69938 11.0153 8.76562 11.1782 8.76562 11.3716C8.76562 11.5649 8.69938 11.7297 8.56689 11.8657C8.43441 11.9982 8.25358 12.0645 8.02441 12.0645C7.79525 12.0645 7.61442 11.9982 7.48193 11.8657C7.34945 11.7297 7.2832 11.5649 7.2832 11.3716Z" fill="#9DA7B0"/>
              </svg>
            </OverlayTrigger>
            <br />
            <Form.Control
              value={val}
              onChange={({ target }) => setVal(target.value)}
              placeholder={''}
            />
          </Form.Group>
          <Form.Group style={{display: 'flex', alignItems: 'center', marginBottom: 10}}>
            <Form.Check
              checked={state}
              onChange={() => setState(state ? false : true)}
              type="checkbox"
              label="Основной исполнитель договора"
            />
            <OverlayTrigger
              placement='top'
              overlay={renderTooltip}
            >
              <svg style={{margin: 'auto 8px'}} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="8" cy="8" r="7.5" stroke="#D5D9DD"/>
                <path d="M8.58838 9.6958H7.39062C7.39421 9.36279 7.42285 9.0835 7.47656 8.85791C7.53027 8.62874 7.61979 8.42106 7.74512 8.23486C7.87402 8.04867 8.04411 7.85173 8.25537 7.64404C8.42008 7.48649 8.56868 7.33789 8.70117 7.19824C8.83366 7.05501 8.93929 6.90462 9.01807 6.74707C9.09684 6.58594 9.13623 6.40153 9.13623 6.19385C9.13623 5.96826 9.09863 5.77669 9.02344 5.61914C8.94824 5.46159 8.83724 5.34163 8.69043 5.25928C8.5472 5.17692 8.36816 5.13574 8.15332 5.13574C7.97428 5.13574 7.80599 5.17155 7.64844 5.24316C7.49089 5.3112 7.36377 5.41862 7.26709 5.56543C7.17041 5.70866 7.11849 5.89844 7.11133 6.13477H5.81689C5.82406 5.68359 5.93148 5.30404 6.13916 4.99609C6.34684 4.68815 6.62614 4.45719 6.97705 4.30322C7.32796 4.14925 7.72005 4.07227 8.15332 4.07227C8.63314 4.07227 9.04313 4.15462 9.3833 4.31934C9.72347 4.48047 9.98307 4.7168 10.1621 5.02832C10.3447 5.33626 10.436 5.70866 10.436 6.14551C10.436 6.46061 10.3734 6.74707 10.248 7.00488C10.1227 7.25911 9.9598 7.49723 9.75928 7.71924C9.55876 7.93766 9.34212 8.15609 9.10938 8.37451C8.90885 8.55713 8.77279 8.75586 8.70117 8.9707C8.62956 9.18197 8.59196 9.42367 8.58838 9.6958ZM7.2832 11.3716C7.2832 11.1782 7.34945 11.0153 7.48193 10.8828C7.61442 10.7467 7.79525 10.6787 8.02441 10.6787C8.25358 10.6787 8.43441 10.7467 8.56689 10.8828C8.69938 11.0153 8.76562 11.1782 8.76562 11.3716C8.76562 11.5649 8.69938 11.7297 8.56689 11.8657C8.43441 11.9982 8.25358 12.0645 8.02441 12.0645C7.79525 12.0645 7.61442 11.9982 7.48193 11.8657C7.34945 11.7297 7.2832 11.5649 7.2832 11.3716Z" fill="#9DA7B0"/>
              </svg>
            </OverlayTrigger>
          </Form.Group>
        </div>
        {showResultField && <Form.Group style={{ height: '100px', maxHeight: '100px', maxWidth: '630px', marginTop: 22 }}>
          <Form.Label style={{ color: '#7F7F7F', fontWeight: 600 }}>
            Полученный результат
          </Form.Label>
          <br />
          <Form.Control
            as="textarea"
            value={resultVal || ''}
            onChange={(e) => setResultVal(e.target.value)}
            style={{ height: '60px', maxHeight: '60px', resize: 'none' }}
          />
        </Form.Group>}
        {Boolean(projects?.length) && (
          <Alert variant="warning" style={{ whiteSpace: 'pre-wrap', marginTop: 15, marginBottom: 7 }}>
            <strong>Другие проекты, в которых добавлен договор:</strong>
            <div style={{marginTop: 15}}>{projects}</div>
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose} variant="outline-secondary">Отменить</Button>
        <Button disabled={loading} variant="primary" onClick={handleSubmitForm}>
          {isSend ? 'Подтвердить' : 'Сохранить'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
